<template>
  <section class="nps-dashboard">
    <CommonParagraph class="overview" title="Aperçu des notes NPS">
      <CompositeNpsList
        :items="nps_store.results"
        :loading="nps_store.loadingResults"
        @search="onSearch"
        @open="openDetail"
      />
      <div class="see-all">
        <CommonButton filled icon="ArrowRight" @click="router.push({ name: 'extranet-nps-stats' })">
          Voir toutes les notes NPS
        </CommonButton>
      </div>
    </CommonParagraph>
    <CompositeNpsAverage class="average" :average="nps_store.average" />
    <ModalNpsDetail ref="modal" />
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonParagraph from '@/components/common/CommonParagraph.vue'
import CompositeNpsList from './CompositeNpsList.vue'
import CompositeNpsAverage from './CompositeNpsAverage.vue'
import ModalNpsDetail from '../modal/ModalNpsDetail.vue'
import { useNpsStore } from '@/stores/gae/store_nps'

const ITEMS_PER_PAGE = 10

const nps_store = useNpsStore()
const router = useRouter()
const modal = ref<InstanceType<typeof ModalNpsDetail>>()
const search = ref('')

onMounted(() => nps_store.fetchResults({ itemsPerPage: ITEMS_PER_PAGE }))

function onSearch(value: string) {
  search.value = value
  nps_store.fetchResults({ itemsPerPage: ITEMS_PER_PAGE, search: search.value })
}

function openDetail(interventionId: number) {
  nps_store.fetchDetail(interventionId).then(() => modal.value?.open())
}
</script>

<style scoped lang="scss">
.nps-dashboard {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.overview {
  flex: 1;
  min-width: 0;
}

.average {
  width: 250px;
}

.see-all {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media screen and (min-width: 640px) {
  .nps-dashboard {
    flex-direction: row;
  }
}
</style>
